module.exports = __webpack_public_path__ + "static/antd-breadcrumb-dropdown-bf167764443c849aee5d204b23d69b19.png";